import { render, staticRenderFns } from "./NoticeLayer.vue?vue&type=template&id=8cdaedf6&"
import script from "./NoticeLayer.vue?vue&type=script&lang=js&"
export * from "./NoticeLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports